import { PlayCircleOutline, QueryBuilderRounded } from '@mui/icons-material'
import { Box, Button, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import LessonBlock from '../../../../lessons/ui/componentes/LessonBlock'
import LessonModal from '../../../../lessons/ui/componentes/LessonModal'
import AdminDetailInfo from '../../../../library/ui/components/AdminDetailInfo'
import LinearProgress from '../../components/LinearProgress'

interface CourseContentProps {
  course: any
  showLessonForm: boolean
  location: any
  handleChangeLesson: (order: number) => void
  authUser: any
}

const CourseContent = ({ course, showLessonForm, location, handleChangeLesson, authUser }: CourseContentProps) => {
  const { t } = useTranslation(['global'])

  return (
    <>
      {location.pathname.includes('admin') && <AdminDetailInfo resourceSelected={course} />}

      {showLessonForm && <LessonModal courseId={course.id} courseTitle={course.title} courseLastOrder={course.lastOrder} />}

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: 286,
              borderRadius: 2,
              backgroundImage: `url(${course.image_url}?${new Date().getHours()})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center center'
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          {course.leaded !== 'null' && (
            <Box pt={1}>
              <Typography variant="subtitle1" color="text.secondary">
                ¿A quién va dirijido?
              </Typography>
              <Typography>{course.leaded}</Typography>
            </Box>
          )}

          {course.requirements !== 'null' && (
            <Box pt={1}>
              <Typography variant="subtitle1" color="text.secondary">
                {t('requirements')}
              </Typography>
              <Typography>{course.requirements}</Typography>
            </Box>
          )}

          {course.duration !== 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main', mb: 2, mt: 2 }}>
              <QueryBuilderRounded />
              <Typography color="inherit">
                {Math.round(course.duration / 60)} {t('hours')}
              </Typography>
            </Box>
          )}

          {course.progress &&
            authUser != null &&
            (authUser.vip_lines.includes(course.line_id) ||
              (course.line_id === null && authUser.vip_brands.includes(course.brand_id)) ||
              [1, 2, 3, 5].includes(authUser.role_id)) && (
              <>
                <Typography variant="body2">
                  {t('admin.courses.course-progress')}: {course.progress.total_lessons_viewed}/{course.lessons.length}{' '}
                </Typography>

                <LinearProgress progress={course.progress ? course.progress.value : 0} vip={course.visibility === 1} />

                {course.lessons.length > course.progress.total_lessons_viewed && (
                  <Box mt={2}>
                    <Button
                      onClick={() => handleChangeLesson(course.progress.total_lessons_viewed + 1)}
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={[
                        course.visibility === 1 && {
                          backgroundColor: 'none',
                          background: 'linear-gradient(89.97deg, #D5B385 -12.76%, #B49568 113.26%)',
                          marginTop: { xs: 3 },
                          width: { xs: '100%' },
                          maxWidth: { xs: '100%' }
                        }
                      ]}
                      startIcon={<PlayCircleOutline />}
                    >
                      {t('continue')}
                    </Button>
                  </Box>
                )}
              </>
            )}
        </Grid>
      </Grid>

      {course.lessons.map((lesson: any) => (
        <LessonBlock
          key={lesson.id}
          lesson={lesson}
          vipContent={course.visibility === 1}
          hasaccess={
            course.visibility === 1 &&
            authUser != null &&
            (authUser.vip_lines.includes(course.line_id) ||
              (course.line_id === null && authUser.vip_brands.includes(course.brand_id)) ||
              [1, 2, 3, 5].includes(authUser.role_id))
          }
        />
      ))}
    </>
  )
}

export default CourseContent
